import type { MasteryState } from "../mastery/masteryState.js";
import type { EloRating } from "../types.js";

export type QuestCheckpoint = {
  conceptId: string;
  /** Step is complete when per-concept skill (Elo) is >= this. */
  minElo: EloRating;
};

export type LinearQuest = {
  id: string;
  steps: readonly QuestCheckpoint[];
};

/**
 * Index of the first step whose concept is still below `minElo`, or `steps.length` if all pass.
 */
export function activeQuestStepIndex(
  steps: readonly QuestCheckpoint[],
  mastery: MasteryState
): number {
  for (let i = 0; i < steps.length; i++) {
    const c = steps[i]!;
    const m = mastery.byConcept[c.conceptId] ?? mastery.defaultRating;
    if (m < c.minElo) return i;
  }
  return steps.length;
}

export type QuestProgress = {
  activeIndex: number;
  total: number;
  isComplete: boolean;
  current: QuestCheckpoint | null;
};

/**
 * @returns `null` when `quest` is missing or has no steps.
 */
export function getLinearQuestProgress(
  quest: LinearQuest | undefined,
  mastery: MasteryState
): QuestProgress | null {
  if (!quest || quest.steps.length === 0) return null;
  const idx = activeQuestStepIndex(quest.steps, mastery);
  const isComplete = idx >= quest.steps.length;
  return {
    activeIndex: idx,
    total: quest.steps.length,
    isComplete,
    current: isComplete ? null : quest.steps[idx]!,
  };
}
